<template>
  <div style="background: #f0f4f7">
    <topSlider/>
    <!--  news-->
    <div v-if="news.topics!=undefined">
      <about-title title="اخبار" page-route="/sub/glass/news/all-news"/>
      <v-container>
        <v-row>
          <v-col v-for="(newsItem,i) in news.topics" :key="i" cols="12">
            <GlassNewsItem :news-item="newsItem"/>
          </v-col>
        </v-row>
        <v-pagination
          color="#25458c"
          v-model="news_page"
          :length="news.total_pages"
        ></v-pagination>
      </v-container>
    </div>
    <!--  events-->
    <div v-if="events.topics!=undefined">
      <about-title :title="$t('رویدادها')" page-route="/sub/glass/news/events"/>
      <v-container>
        <v-row>
          <v-col v-for="(newsItem,i) in events.topics" :key="i" cols="12">
            <GlassNewsItem :news-item="newsItem"/>
          </v-col>
        </v-row>
        <v-pagination
          color="#25458c"
          v-model="events_page"
          :length="events.total_pages"
        ></v-pagination>
      </v-container>
    </div>
    <!--gallery-->
   <div  >
     <about-title page-route="/sub/glass/news/gallery" :title="$t('گالری')"></about-title>
     <v-container>
       <v-row>
         <v-col v-for="(item,i) in galleryItem.topics" :key="i" cols="6">
           <GlassGalleryItem :item="item"/>
         </v-col>
       </v-row>
       <v-pagination
        color="#25458c"
          v-model="gallery_page"
          :length="galleryItem.total_pages"
        ></v-pagination>
     </v-container>
   </div>
    <!--  projects-->
    <div v-if="projects.topics!=undefined">
      <about-title :title="$t('پروژه ها')" page-route="/sub/glass/projects"/>
      <v-container>
        <v-row>
          <v-col v-for="(newsItem,i) in projects.topics" :key="i" cols="12">
            <GlassNewsItem :news-item="newsItem"/>
          </v-col>
        </v-row>
        <v-pagination
        color="#25458c"
          v-model="projects_page"
          :length="projects.total_pages"
        ></v-pagination>
      </v-container>
    </div>

  </div>
</template>

<script>

import NewsItem from "./news/components/NewsItem";
import TopSlider from "./components/TopSlider";

import Gallery from "./gallery/components/gallery";
import ArticlesItems from "../Technical/articles/components/articlesItems";
import EventsItems from "./events/components/eventsItems";
import certificate from "../Technical/certificates/components/certificates";
import Projects from "./projects/BlockProjects";
import AboutTitle from "../About/Components/AboutTitle";
import {mapState} from "vuex";
import GlassNewsItem from "../subNews/components/GlassNewsItem";
import GlassGalleryItem from "./gallery/components/GlassGalleryItem";

export default {
  name: "blockNews",
  data(){
    return {
      projects_page:1,
      gallery_page:1,
      events_page:1,
      news_page:1,
    }
  },
  components: {
    GlassGalleryItem,
    GlassNewsItem,
    AboutTitle, Projects, certificate, EventsItems, ArticlesItems, Gallery, NewsItem, TopSlider
  },
  created() {
    this.$store.dispatch('glassManagement/getGlassNews',{
      page:this.news_page,
      limit:5
    });
    this.$store.dispatch('glassManagement/getGlassEvents',{
      page:this.events_page,
      limit:5
    });
    this.$store.dispatch('glassManagement/getGlassGallery',{
      page:this.gallery_page,
      limit:5
    });
    this.$store.dispatch('glassManagement/getGlassProjects',{
      page:this.projects_page,
      limit:5
    });
  },
  watch:{
    projects_page(){
      this.$store.dispatch('glassManagement/getGlassProjects',{
        page:this.projects_page,
        limit:5
      });
    },
    news_page(){
      this.$store.dispatch('glassManagement/getGlassNews',{
      page:this.news_page,
      limit:5
    });
    },
    events_page(){
      this.$store.dispatch('glassManagement/getGlassEvents',{
      page:this.events_page,
      limit:5
    });
    },
    gallery_page(){
      this.$store.dispatch('glassManagement/getGlassGallery',{
      page:this.gallery_page,
      limit:5
    });
    }
  },
  computed: {
    ...mapState({
      news: state => state.glassManagement.glassNews,
      events: state => state.glassManagement.glassEvents,
      galleryItem: state => state.glassManagement.glassGallery,
      projects:state => state.glassManagement.glassProjects,
    })
  }
}
</script>
<style scoped>

.slide-1 {
  height: 80vh;
  width: 100vw;
  background: url("../../../../../assets/images/home-slider/9.jpg") center no-repeat;
  background-size: cover;
}

.slide-2 {
  height: 80vh;
  width: 100vw;
  background: url("../../../../../assets/images/home-slider/1.jpg") center no-repeat;
  background-size: cover;
}

.slide-3 {
  height: 80vh;
  width: 100vw;
  background: url("../../../../../assets/images/home-slider/2.jpg") center no-repeat;
  background-size: cover;
}

.slide-4 {
  height: 80vh;
  width: 100vw;
  background: url("../../../../../assets/images/home-slider/12.jpg") center no-repeat;
  background-size: cover;
}

.slide-img {
  position: relative;
  transition: background 8s;
  height: 90vh;
}


.dots-box-position {
  position: absolute;
  bottom: 30px;
  right: 0;
  left: 0;
  height: 60px;
}

.slider {
  background-color: rgba(8, 70, 190, 0.44);
  height: 100%;
  z-index: 9999;
  animation-play-state: paused;
  animation: skew ease-in infinite;

}

@keyframes skew {
  from {
    width: 0
  }
  to {
    width: 100%
  }

}

.paused {
  animation-play-state: paused;
  animation-duration: 4s;
}

.resumed {
  animation-play-state: running;
  animation-duration: 4s;
}
</style>
